import { useState } from "react";
import { LoadingPage, PageSubtitle, PageTitle } from "../../widgets/small-widgets";
import { collection, getDocs, limit, orderBy, query, startAfter } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { Mail } from "../../classes/mail.tsx";
import RenderMail from "../../widgets/mails/mail.tsx";
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Mails({}) {
    const { t } = useTranslation();

    const isMobile = useMediaQuery("only screen and (max-width : 450px)");

    const [mails, setMails] = useState(undefined);
    const [lastMail, setLastMail] = useState(null);
    const [loadAmount, setLoadAmount] = useState(30);

    async function getMails() {

        var q;

        if (lastMail != null) {
            q = query(collection(db, 'mail'), orderBy('delivery', 'desc'), startAfter(lastMail), limit(loadAmount));
        } else {
            q = query(collection(db, 'mail'), orderBy('delivery', 'desc'), limit(loadAmount));
        }

        const newMails = [];

        const mailsData = await getDocs(q);
        mailsData.docs.forEach(doc => {
            const mail = Mail.fromJson(doc.data(), doc.id);
            console.log(mail);
            newMails.push(mail);
        });

        if (mails != undefined) {
            setMails(mails.concat(newMails));
        } else {
            setMails(newMails);
        }
    }

    if (mails === undefined) {
        getMails();
    }

    return <div>
        <Link to={"/mails/local"} style={{margin: '2px 10px'}}>{t('mails.locals.title')}</Link>
        <div style={{margin: '15px 10px'}}>
            <PageTitle>{t('navigation.mails')}</PageTitle>
        </div>
        {mails != undefined
            ? mails.length != 0
                ? <div>
                    {mails.map((mail, index) => <RenderMail mail={mail} key={index} isMobile={isMobile}/>)}
                </div> : <div style={{textAlign: 'center'}}>
                    <PageSubtitle>{t('mails.noMails')}</PageSubtitle>
                </div>
            : <LoadingPage/>
        }
    </div>;
}